import { Navigate, RouteObject } from 'react-router-dom';
import { Http404Suspense } from '../pages/http404-suspense';
import { RouteErrorFallback } from '../components/errors/route-error-fallback';
import HubLoginPage from '../pages/hub/hub-login-page';
import HubRegisterPage from '../pages/hub/hub-register-page';
import HubPasswordResetPage from '../pages/hub/hub-password-reset-page';
import HubSetPasswordPage from '../pages/hub/hub-set-password-page';
import HubMcpConnectPage from '../pages/hub/hub-mcp-connect-page';
import HubReschedulePage from '../pages/hub/hub-reschedule-page';
import {
    HUB_LOGIN_PATH,
    HUB_REGISTER_PATH,
    HUB_FORGOT_PASSWORD_PATH,
    HUB_SET_PASSWORD_PATH,
    HUB_MCP_CONNECT_PATH,
    HUB_RESCHEDULE_PATH
} from './paths';
import { routeTitle } from './route-title';

export const hubRoutes: RouteObject[] = [
    {
        path: '/',
        errorElement: <RouteErrorFallback />
    },
    {
        path: '/ux',
        element: <Navigate to={HUB_LOGIN_PATH} replace />,
        errorElement: <RouteErrorFallback />
    },
    {
        path: HUB_LOGIN_PATH,
        handle: routeTitle('Sign In'),
        element: <HubLoginPage />,
        errorElement: <RouteErrorFallback />
    },
    {
        path: HUB_REGISTER_PATH,
        handle: routeTitle('Create Account'),
        element: <HubRegisterPage />,
        errorElement: <RouteErrorFallback />
    },
    {
        path: HUB_FORGOT_PASSWORD_PATH,
        handle: routeTitle('Reset Password'),
        element: <HubPasswordResetPage />,
        errorElement: <RouteErrorFallback />
    },
    {
        path: HUB_SET_PASSWORD_PATH,
        handle: routeTitle('Set Password'),
        element: <HubSetPasswordPage />,
        errorElement: <RouteErrorFallback />
    },
    {
        // Where the MCP worker sends a customer to sign in and approve an AI assistant
        // (`Cloudflare/mcp/docs/connect-handoff.md`). It carries `?handoff=…`, and the page shows
        // the login form in place when there is no session so that query string survives.
        path: HUB_MCP_CONNECT_PATH,
        handle: routeTitle('Connect an AI Assistant'),
        element: <HubMcpConnectPage />,
        errorElement: <RouteErrorFallback />
    },
    {
        // ROBO-616: reschedule / cancel an appointment. Open to a guest holding the site's link
        // (the guid segment) and to anyone signed in; with neither, the page shows the login form
        // in place, so the address survives the sign-in.
        path: HUB_RESCHEDULE_PATH,
        handle: routeTitle('Reschedule Appointment'),
        element: <HubReschedulePage />,
        errorElement: <RouteErrorFallback />
    },
    {
        path: '*',
        handle: routeTitle('Page Not Found'),
        element: <Http404Suspense />,
        errorElement: <RouteErrorFallback />
    }
];
